import request from '@/utils/request';
/**获取列表数据 */
export function frontPage(data) {
  return request.post('admin/dashboard/front-page', data);
}